import { lazy } from 'react';
import type { AppModuleManifest } from '../types';

const manifest: AppModuleManifest = {
  slug: 'vorlagen',
  name: 'Vorlagen',
  icon: 'LayoutTemplate',
  persistent: false,
  routes: [
    { path: '/',              component: lazy(() => import('./pages/VorlagenListPage')),          label: 'Vorlagen',      navigation: 'main',   permission: 'vorlagen.write' },
    { path: '/aktenstruktur', component: lazy(() => import('./pages/VorlagenAktenstrukturPage')), label: 'Aktenstruktur', navigation: 'main',   roles: ['admin', 'gf'] },
    { path: '/:slug',         component: lazy(() => import('./pages/VorlagenDetailPage')),                                navigation: 'hidden', permission: 'vorlagen.write' },
  ],
  roles: ['admin', 'gf'],
};

export default manifest;
